/**
 * 调 Nexora 跨企业用户目录（不走 OpenIM）。
 * 返回的 openim_user_id 再交给 SDK addFriend。
 */
import { authHeaders } from "../../auth/token";
import { getApiBase } from "../../api/client";
import type { DirectoryUser } from "../types";

/**
 * GET /api/im/directory/search：跨企业搜人（不隔离租户）。
 * q: 用户名关键字。
 * limit: 最大返回条数，默认 20。
 * 返回：命中用户列表；加好友时用其中的 openim_user_id（不是 username）。
 */
export async function searchDirectoryUsers(
  q: string,
  limit = 20,
): Promise<DirectoryUser[]> {
  const base = getApiBase();
  const url =
    `${base}/api/im/directory/search?` +
    new URLSearchParams({ q: q.trim(), limit: String(limit) });
  const resp = await fetch(url, {
    method: "GET",
    headers: { ...authHeaders() },
  });
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`搜人失败 HTTP ${resp.status}: ${text}`);
  }
  const data = (await resp.json()) as { items: DirectoryUser[] };
  return data.items || [];
}